<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i *ngIf="this.id && !visualizar" class="fas fa-pencil-alt pr-2"></i>
        <i *ngIf="this.id && visualizar" class="fas fa-search pr-2"></i>
        <i *ngIf="!this.id" class="far fa-file pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body wrapper">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
        <div class="row mb-2">
            <div class="col-md-2 mb-2">
                <label for="inputIdentificador" class="mb-1">Identificador</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputIdentificador" class="form-control form-control-sm" readonly
                        [value]="model.identificador === 0 ? '-' : model.identificador" />
                </div>
            </div>

            <div class="col-md-10 mb-2">
                <label for="inputTitulo" class="mb-1">Título da Ação</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputTitulo" class="form-control form-control-sm" readonly
                        [value]="model.titulo" />
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputDescricao" class="mb-1">Descrição da Ação</label>
                <div class="form-control" [innerHTML]="model.descricao"
                    style="min-height: 150px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;">
                </div>
            </div>

            <div class="col-md-6 mb-2">
                <label for="inputResponsavel" class="mb-1">Responsável</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputResponsavel" class="form-control form-control-sm" readonly
                        [value]="model.responsavelNome" />
                </div>
            </div>

            <div class="col-md-4 mb-2">
                <label for="inputPrazo" class="mb-1">Prazo de Implementação</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputPrazo" class="form-control form-control-sm" readonly
                        [value]="model.prazo ? (model.prazo | date:'dd/MM/yyyy') : '-'" />
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label class="mb-1">Recomendações</label>
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceRecomendacao" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['titulo', 'actions']" class="bg-light">
                        </tr>
                        <ng-container matColumnDef="titulo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Recomendação
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.recomendacao?.titulo">-</span>
                                <span *ngIf="element?.recomendacao?.titulo">{{
                                    element.recomendacao.titulo }}</span>
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                                        (click)="modalRecomendacao(element)">
                                        <i class="far fas fa-eye"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-row *matRowDef="let row; columns: ['titulo', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceRecomendacao.data?.length > 0">
                        Nenhuma recomendação vinculada
                    </h5>
                    <mat-paginator #tabelaRecomendacaoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label class="mb-1 d-block">Avaliação do Auditor</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="radioAprovada" [value]="2" name="opcao"
                        [(ngModel)]="avaliacao" [ngModelOptions]="{standalone: true}" [disabled]="visualizar" />
                    <label class="form-check-label" for="radioAprovada">
                        Aprovada
                    </label>
                </div>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="radioAprovadaRessalva" [value]="3" name="opcao"
                        [(ngModel)]="avaliacao" [ngModelOptions]="{standalone: true}" [disabled]="visualizar" />
                    <label class="form-check-label" for="radioAprovadaRessalva">
                        Aprovada com Ressalvas
                    </label>
                </div>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="radioRejeitada" [value]="4" name="opcao"
                        [(ngModel)]="avaliacao" [ngModelOptions]="{standalone: true}" [disabled]="visualizar" />
                    <label class="form-check-label" for="radioRejeitada">
                        Rejeitada
                    </label>
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label class="mb-1">Justificativas</label>
                <textarea type="text" class="form-control" rows="4" maxlength="2000" [readonly]="visualizar"
                    [(ngModel)]="model.justificativaAvaliacao" [ngModelOptions]="{standalone: true}">
                </textarea>
            </div>

            <div class="col-md-5 mb-2">
                <label for="inputnivelRelevancia" class="mb-1">Nível da Ação</label>
                <ng-select id="nivelRelevancia" [readonly]="visualizar" name="nivelRelevancia"
                    [(ngModel)]="model.nivelRelevancia" [items]="nivelRelevanciaList" bindLabel="descricao"
                    placeholder="Selecione um Nível de Relevância">
                </ng-select>
            </div>

        </div>
    </form>
</div>
<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <div class="btn-group" [hidden]="visualizar">
            <button class="btn btn-primary btn-sm mr" (click)="salvar()">
                <i class="far fa-save"></i> Salvar
            </button>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()" [hidden]="visualizar">
            <i class="fas fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()" [hidden]="!visualizar">
            <i class="fas fa-times"></i> Sair
        </button>
    </div>
</div>